<template>
   	<div class="songList">
   		<ul class="songListUl">
   			<li v-for="(item,index) in songList" :class="{'current':iscurrent==index}" @click="play(index)"><span>{{item.title}}</span></li>
   		</ul>
   	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	
  export default {
    data () {
      return {
      	
      }
    },
    computed: {
    	...mapGetters(['iscurrent','songList'])
    },
    components:{

  	},
    mounted:function(){
	
    },
    methods: {
      play:function(index){
      	this.$store.commit('setIscurrent', index);
      	this.$store.dispatch('playSong');
      	this.$store.commit('imgPause',false);
      },    
    }
  }
</script>

<style>
.songList{width: 100%;position: absolute;top:38%;color: #fff;}
.songListUl{width: 100%;padding-left: 20px;box-sizing: border-box;overflow: hidden;background: url(../assets/images/bg01.jpg);background-size:15%;}
.songListUl li{color: #ccc;width: 100%;border-bottom: 1px solid #333;padding: 15px 0px 15px 6px;font-size: 14px;box-sizing: border-box;
background: url(../assets/images/list_icon.png) no-repeat 95% center;background-size:10%;}
.songListUl li>span{display: block;width: 82%;;}
.songListUl .current{color: #7de87d;background: url(../assets/images/list_icon2.png) no-repeat 95% center;background-size:10%;}
</style>


// WEBPACK FOOTER //
// songList.vue?f2691038